import { useEffect, useState } from 'react'

import { Wrapper } from './styles'
import Header from '../../components/header_home'
import Missions from '../../components/missions'
import GameWrapper from '../../components/game_wrapper'
import { useGameWrapper } from '../../contexts'
import { MissionModel } from '../../../domain/model/mission.model'

const Mission = () => {
  const { currentMission, restoreMissionsByStorage } = useGameWrapper()
  const [mission, setMission] = useState<MissionModel|null>()

  async function loadMission () {
    await restoreMissionsByStorage()
  }

  useEffect(() => {
    (async () => {
      loadMission()
    })()
  }, [])

  useEffect(() => {
    setMission(currentMission)
    window.scrollTo(0, 0)
  }, [currentMission])

  return (
    <Wrapper>
      <Header />
      <GameWrapper>
        {mission && <Missions missionType={mission.type} />}
      </GameWrapper>
    </Wrapper>
  )
}

export default Mission
